module.exports = __webpack_public_path__ + "img/art4-img2.3d2b9c01.jpeg";